export default __webpack_public_path__ + "static/media/vincent.5cc4123e.webp";